import { createAsyncThunk } from "@reduxjs/toolkit"
import { getRequest } from "./utils/GetRequest"
import { SuperAdminEmail } from "../model/super-admin-email/SuperAdminEmail.model";

export const getSuperAdminEmail = createAsyncThunk<SuperAdminEmail>('apppersonamappings/configurations' , async () => {
    const response = await getRequest<SuperAdminEmail>("dev/apppersonamappings/configurations");
    return response.data
  })

